export default "__VITE_ASSET__aa282da6__"